import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaroSphereXgLogoMini = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 47.719002 62",
	xmlSpace: "preserve",
	"sodipodi:docname": "faro-sphere-xg-logo-mini.svg",
	width: 47.719002,
	height: 62,
	"inkscape:version": "1.2 (dc2aeda, 2022-05-15)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", {
			id: "defs2294",
			children: [
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_1_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 158.14349,
					x2: 15.5963,
					y2: 158.14349,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1432"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1434"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1436"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1438"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1440"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000122691939579634749710000016140102806956635832_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 81.980797,
					x2: 15.5963,
					y2: 81.980797,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1445"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1447"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1449"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1451"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1453"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000108281421602319004610000002935681579854070442_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 67.1548,
					x2: 15.5963,
					y2: 67.1548,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1458"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1460"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1462"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1464"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1466"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000062899252350258803400000006452798929521711257_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 96.7882,
					x2: 15.5963,
					y2: 96.7882,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1471"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1473"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1475"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1477"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1479"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000000199521709349947990000013169840349870900097_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 66.937401,
					x2: 15.5963,
					y2: 66.937401,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1484"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1486"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1488"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1490"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1492"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000139986685407783468530000007711435610983319217_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 96.882797,
					x2: 15.5963,
					y2: 96.882797,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1497"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1499"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1501"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1503"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1505"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000145767616473413220620000003275638393888781987_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 81.944901,
					x2: 15.5963,
					y2: 81.944901,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1510"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1512"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1514"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1516"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1518"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000168828492323578885110000006331516876797389706_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 52.795101,
					x2: 15.5963,
					y2: 52.795101,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1523"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1525"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1527"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1529"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1531"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000119825009282355398870000002427391825971570065_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 110.8329,
					x2: 15.5963,
					y2: 110.8329,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1536"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1538"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1540"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1542"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1544"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000135687005885930954780000007562071303343076235_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 81.890999,
					x2: 15.5963,
					y2: 81.890999,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1549"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1551"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1553"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1555"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1557"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000027573844424622963070000005045413081647210387_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 52.891998,
					x2: 15.5963,
					y2: 52.891998,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1562"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1564"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1566"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1568"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1570"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000137812898909728225410000000398060100545818550_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 110.7534,
					x2: 15.5963,
					y2: 110.7534,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1575"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1577"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1579"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1581"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1583"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000036210321468949231540000007790552816983797179_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 110.7709,
					x2: 15.5963,
					y2: 110.7709,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1588"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1590"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1592"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1594"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1596"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000177472600690211122990000006503221024441719981_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 52.665901,
					x2: 15.5963,
					y2: 52.665901,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1601"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1603"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1605"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1607"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1609"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000043438139329708308660000015822744963709389210_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 66.994102,
					x2: 15.5963,
					y2: 66.994102,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1614"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1616"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1618"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1620"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1622"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000050621569454675735740000001964733990937374595_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 39.767601,
					x2: 15.5963,
					y2: 39.767601,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1627"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1629"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1631"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1633"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1635"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000099660364721125034880000005073820371753241730_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 96.813797,
					x2: 15.5963,
					y2: 96.813797,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1640"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1642"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1644"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1646"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1648"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000152981512894964917610000006976944404649027202_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 123.4884,
					x2: 15.5963,
					y2: 123.4884,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1653"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1655"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1657"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1659"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1661"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000059298183092284374220000017110963526683306148_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 123.457,
					x2: 15.5963,
					y2: 123.457,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1666"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1668"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1670"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1672"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1674"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000052810101756662128740000009060811739823908506_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 39.749199,
					x2: 15.5963,
					y2: 39.749199,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1679"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1681"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1683"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1685"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1687"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000030467902775817769060000007710743212976295583_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 81.895302,
					x2: 15.5963,
					y2: 81.895302,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1692"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1694"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1696"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1698"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1700"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000180341006968639202810000003347100774493131935_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 134.5777,
					x2: 15.5963,
					y2: 134.5777,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1705"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1707"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1709"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1711"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1713"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000172437836869410601830000017357335535451569809_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 28.2041,
					x2: 15.5963,
					y2: 28.2041,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1718"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1720"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1722"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1724"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1726"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000078723697224134013200000007992507812905159567_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 39.7673,
					x2: 15.5963,
					y2: 39.7673,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1731"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1733"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1735"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1737"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1739"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000163053878163007453100000004624683950133212288_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 123.3674,
					x2: 15.5963,
					y2: 123.3674,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1744"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1746"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1748"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1750"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1752"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000028292862012794903440000011988512145044200613_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 28.1693,
					x2: 15.5963,
					y2: 28.1693,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1757"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1759"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1761"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1763"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1765"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000042718578562191629250000012247638859564900779_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 134.5986,
					x2: 15.5963,
					y2: 134.5986,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1770"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1772"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1774"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1776"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1778"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000132770191053423491140000007632210908060457144_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 110.7109,
					x2: 15.5963,
					y2: 110.7109,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1783"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1785"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1787"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1789"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1791"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000163068424181906487300000009725152635015269520_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 52.724998,
					x2: 15.5963,
					y2: 52.724998,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1796"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1798"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1800"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1802"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1804"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000034077442624591069820000009218002277992221871_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 28.1036,
					x2: 15.5963,
					y2: 28.1036,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1809"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1811"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1813"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1815"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1817"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000157995984871680439450000004804474724353645455_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 134.5278,
					x2: 15.5963,
					y2: 134.5278,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1822"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1824"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1826"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1828"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1830"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000176037832161755113060000007618979071475921058_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 96.7388,
					x2: 15.5963,
					y2: 96.7388,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1835"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1837"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1839"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1841"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1843"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000113354167512336820520000006842766831457106848_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 66.833298,
					x2: 15.5963,
					y2: 66.833298,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1848"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1850"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1852"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1854"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1856"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000064318501803466698530000000160626057362371239_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 143.85921,
					x2: 15.5963,
					y2: 143.85921,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1861"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1863"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1865"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1867"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1869"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000124135087498030474290000011655190472795675011_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 143.8226,
					x2: 15.5963,
					y2: 143.8226,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1874"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1876"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1878"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1880"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1882"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000107549470292331867980000014750780667726015912_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 18.377899,
					x2: 15.5963,
					y2: 18.377899,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1887"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1889"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1891"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1893"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1895"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000102516119588716095730000007221224109596897212_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 18.347799,
					x2: 15.5963,
					y2: 18.347799,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1900"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1902"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1904"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1906"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1908"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000128477840900087556850000015154316707693435269_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 28.1134,
					x2: 15.5963,
					y2: 28.1134,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1913"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1915"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1917"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1919"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1921"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000056407624679554967980000016847754198413517485_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 134.4903,
					x2: 15.5963,
					y2: 134.4903,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1926"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1928"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1930"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1932"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1934"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000167376588874201946570000018213694390410607493_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 123.3532,
					x2: 15.5963,
					y2: 123.3532,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1939"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1941"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1943"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1945"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1947"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000057112839509476852940000013562575419161609146_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 39.610401,
					x2: 15.5963,
					y2: 39.610401,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1952"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1954"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1956"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1958"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1960"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000079460158622750419550000016549781586481150880_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 143.87131,
					x2: 15.5963,
					y2: 143.87131,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1965"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1967"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1969"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1971"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1973"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000070106482567904741890000001921094174100306831_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 18.2677,
					x2: 15.5963,
					y2: 18.2677,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1978"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1980"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1982"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1984"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1986"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000144295474034070890990000007817825231218805413_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 10.5442,
					x2: 15.5963,
					y2: 10.5442,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop1991"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop1993"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop1995"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop1997"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop1999"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000127730992518369212560000004935042208330688432_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 151.0282,
					x2: 15.5963,
					y2: 151.0282,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2004"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2006"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2008"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2010"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2012"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000110446295796125680660000011187903342483015593_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 81.791801,
					x2: 15.5963,
					y2: 81.791801,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2017"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2019"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2021"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2023"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2025"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000070807209349108861420000004662275095824104121_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 110.6386,
					x2: 15.5963,
					y2: 110.6386,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2030"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2032"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2034"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2036"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2038"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000181766665731215728440000002795684730232666788_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 52.471199,
					x2: 15.5963,
					y2: 52.471199,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2043"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2045"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2047"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2049"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2051"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000139254581274291156830000007336169736159569559_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 151.05341,
					x2: 15.5963,
					y2: 151.05341,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2056"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2058"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2060"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2062"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2064"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000153672128272945661450000018077986166064404644_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 10.5076,
					x2: 15.5963,
					y2: 10.5076,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2069"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2071"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2073"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2075"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2077"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000088813030132609527630000000840570861706508965_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 96.663498,
					x2: 15.5963,
					y2: 96.663498,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2082"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2084"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2086"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2088"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2090"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000042003881320679131280000000817094036635403146_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 66.618301,
					x2: 15.5963,
					y2: 66.618301,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2095"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2097"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2099"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2101"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2103"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000170279427261400862440000004292432490584434101_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 4.9808998,
					x2: 15.5963,
					y2: 4.9808998,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2108"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2110"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2112"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2114"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2116"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000116941336711554308390000001645358138721819049_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 18.186399,
					x2: 15.5963,
					y2: 18.186399,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2121"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2123"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2125"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2127"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2129"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000051358159326764444480000009488012094096436618_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 143.793,
					x2: 15.5963,
					y2: 143.793,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2134"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2136"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2138"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2140"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2142"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000114040064972220396600000017173229231029556104_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 10.3908,
					x2: 15.5963,
					y2: 10.3908,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2147"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2149"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2151"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2153"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2155"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000077319424412082093350000011191704370380397242_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 134.4809,
					x2: 15.5963,
					y2: 134.4809,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2160"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2162"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2164"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2166"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2168"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000153690920891616182350000006129345594591774860_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 27.889601,
					x2: 15.5963,
					y2: 27.889601,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2173"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2175"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2177"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2179"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2181"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000151545741716367953150000006428574012513285305_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 151.0825,
					x2: 15.5963,
					y2: 151.0825,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2186"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2188"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2190"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2192"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2194"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000067958700782405560120000004250833630487242895_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 123.3154,
					x2: 15.5963,
					y2: 123.3154,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2199"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2201"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2203"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2205"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2207"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000102512024678794956260000011740393736788144049_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 39.3451,
					x2: 15.5963,
					y2: 39.3451,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2212"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2214"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2216"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2218"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2220"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000104674109392723083100000001383324520108186250_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 4.9221001,
					x2: 15.5963,
					y2: 4.9221001,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2225"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2227"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2229"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2231"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2233"
						})
					]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "SVGID_00000097486671545370010930000015418153806677484168_",
					gradientUnits: "userSpaceOnUse",
					x1: 123.6786,
					y1: 81.682098,
					x2: 15.5963,
					y2: 81.682098,
					gradientTransform: "translate(-10.987127,-3.8483376)",
					children: [
						/* @__PURE__ */ _jsx("stop", {
							offset: .1242,
							style: { stopColor: "#01426A" },
							id: "stop2238"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .6472,
							style: { stopColor: "#3455DB" },
							id: "stop2240"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .7296,
							style: { stopColor: "#2C60DB" },
							id: "stop2242"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: .8738,
							style: { stopColor: "#177DDD" },
							id: "stop2244"
						}),
						/* @__PURE__ */ _jsx("stop", {
							offset: 1,
							style: { stopColor: "#009CDE" },
							id: "stop2246"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview2292",
			pagecolor: "#ffffff",
			bordercolor: "#999999",
			borderopacity: 1,
			"inkscape:showpageshadow": 0,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			showgrid: "false",
			"inkscape:zoom": 10.289752,
			"inkscape:cx": 37.027131,
			"inkscape:cy": 32.216519,
			"inkscape:window-width": 1680,
			"inkscape:window-height": 975,
			"inkscape:window-x": 63,
			"inkscape:window-y": 86,
			"inkscape:window-maximized": 0,
			"inkscape:current-layer": "Layer_1"
		}),
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			id: "style1416",
			children: "\n	.st0{fill:#01426A;}\n	.st1{fill:url(#SVGID_1_);}\n	.st2{fill:url(#SVGID_00000040546051797289469870000002198355272927233979_);}\n	.st3{fill:url(#SVGID_00000167364877519538124380000013748876787806712253_);}\n	.st4{fill:url(#SVGID_00000137846451534802918270000000944316655442206601_);}\n	.st5{fill:url(#SVGID_00000021108837693389970460000011984316430989914759_);}\n	.st6{fill:url(#SVGID_00000098938653854699812820000002173604626904571829_);}\n	.st7{fill:url(#SVGID_00000057120290882901579600000013856563784364539029_);}\n	.st8{fill:url(#SVGID_00000150821416528905583350000015205038847207751853_);}\n	.st9{fill:url(#SVGID_00000104671059017507468280000000999823716082165153_);}\n	.st10{fill:url(#SVGID_00000009592046495905975070000001533760403300256154_);}\n	.st11{fill:url(#SVGID_00000107564791030732469120000007065129523679085203_);}\n	.st12{fill:url(#SVGID_00000179608377744423675010000010762970780771158181_);}\n	.st13{fill:url(#SVGID_00000051355439391650356670000010832882049352704703_);}\n	.st14{fill:url(#SVGID_00000098193214001075066190000008620605126581851803_);}\n	.st15{fill:url(#SVGID_00000039855679829776869050000012449081222302290585_);}\n	.st16{fill:url(#SVGID_00000147905035050183669860000001328069283253796744_);}\n	.st17{fill:url(#SVGID_00000072240812150889759870000006271747650873076116_);}\n	.st18{fill:url(#SVGID_00000106860630962222828130000006945955914560806552_);}\n	.st19{fill:url(#SVGID_00000073001221397046880220000015198386965435357845_);}\n	.st20{fill:url(#SVGID_00000122715889737267664360000003367819401207350454_);}\n	.st21{fill:url(#SVGID_00000114771560039894107780000000566086488451734191_);}\n	.st22{fill:url(#SVGID_00000018955436845782918840000011756482734926510755_);}\n	.st23{fill:url(#SVGID_00000087392830857141529590000009027758111864812725_);}\n	.st24{fill:url(#SVGID_00000163765654993475713670000011062718395734190762_);}\n	.st25{fill:url(#SVGID_00000167387281860178701050000012906343164638717628_);}\n	.st26{fill:url(#SVGID_00000166663196913803074070000016044301525410969232_);}\n	.st27{fill:url(#SVGID_00000037686239348094743560000000704567834351931068_);}\n	.st28{fill:url(#SVGID_00000016784884015852823220000011139856519089451909_);}\n	.st29{fill:url(#SVGID_00000083050854690897835600000010240603955966460835_);}\n	.st30{fill:url(#SVGID_00000148634626526152511270000008170494002004151224_);}\n	.st31{fill:url(#SVGID_00000080888563940550968090000005468691863713866918_);}\n	.st32{fill:url(#SVGID_00000160893894063297601280000008112962613127205553_);}\n	.st33{fill:url(#SVGID_00000157987508295099449240000000913105388553013155_);}\n	.st34{fill:url(#SVGID_00000147930031974078518020000018015034614077675935_);}\n	.st35{fill:url(#SVGID_00000054955628669898633870000010173899806823390601_);}\n	.st36{fill:url(#SVGID_00000146492029970994341400000016223251143647414163_);}\n	.st37{fill:url(#SVGID_00000084512641849144729140000003890689780857987480_);}\n	.st38{fill:url(#SVGID_00000088093477262739040570000002409123030158978950_);}\n	.st39{fill:url(#SVGID_00000051358088862295835690000014474129385579936163_);}\n	.st40{fill:url(#SVGID_00000088850963676522008960000001701494582735163296_);}\n	.st41{fill:url(#SVGID_00000075874894605128738050000017567473257504265884_);}\n	.st42{fill:url(#SVGID_00000067959291571022763410000001346068528765997502_);}\n	.st43{fill:url(#SVGID_00000116934556279939725790000009823528414146602371_);}\n	.st44{fill:url(#SVGID_00000058564489310103224050000008951008196741239943_);}\n	.st45{fill:url(#SVGID_00000089564248860660192420000008747381358922404278_);}\n	.st46{fill:url(#SVGID_00000123423934980589226150000017545437015264673169_);}\n	.st47{fill:url(#SVGID_00000026138075786323947340000007041902683796904614_);}\n	.st48{fill:url(#SVGID_00000000201369232674107280000007409171315416279195_);}\n	.st49{fill:url(#SVGID_00000001634822474222966310000002626473098077549215_);}\n	.st50{fill:url(#SVGID_00000124861696610327674650000003586548138758756023_);}\n	.st51{fill:url(#SVGID_00000174597861737803205690000002389451342686165391_);}\n	.st52{fill:url(#SVGID_00000070823746332758879430000016365397778784031897_);}\n	.st53{fill:url(#SVGID_00000180347080003485736680000007361201731618155152_);}\n	.st54{fill:url(#SVGID_00000120523595313064426440000008668600769727456168_);}\n	.st55{fill:url(#SVGID_00000136370071058531524440000017856903098021573299_);}\n	.st56{fill:url(#SVGID_00000090987507904781873890000011842984770022856117_);}\n	.st57{fill:url(#SVGID_00000039091428596621854160000010954719562876201090_);}\n	.st58{fill:url(#SVGID_00000173860176192266856890000017885109862100462242_);}\n	.st59{fill:url(#SVGID_00000093871348102315806290000012187944300316896405_);}\n	.st60{fill:url(#SVGID_00000168833215343640192650000015643361621992756130_);}\n	.st61{fill:url(#SVGID_00000114769172791298981210000011436092973874126004_);}\n	.st62{fill:url(#SVGID_00000084520721056511788550000011816367663142021804_);}\n	.st63{fill:url(#SVGID_00000173121849272652694280000005263904582975413633_);}\n	.st64{fill:#3455DB;}\n"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "g5422",
			transform: "scale(0.41438222)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "st1",
					d: "m 79.346873,154.30267 c 0.272,-0.004 0.544,-0.009 0.816,-0.016 -0.259,0.005 -0.604,0.011 -0.863,0.016 0.015,0 0.033,0 0.047,0 z",
					id: "path1443",
					style: { fill: "url(#SVGID_1_)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000122691939579634749710000016140102806956635832_)" },
					d: "m 6.2748734,77.102674 c -0.058,2.452 0.317,5.016 1.031,7.034 1.539,4.35 5.2129996,7.371 8.1099996,1.727 2.506,-6.086 1.181,-14.284 -1.632,-17.275 -3.396,-3.611 -7.3259996,0.845 -7.5089996,8.514 z",
					id: "path1456"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000108281421602319004610000002935681579854070442_)" },
					d: "m 14.289873,66.832674 c 0.68,5.507 5.15,9.336 9.933,3.342 3.809,-5.7 2.98,-12.027 1.174,-14.699 -3.183,-4.709 -9.398,-0.924 -10.903,6.64 v 0 c -0.304,1.528 -0.38,3.291 -0.204,4.717 z",
					id: "path1469"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000062899252350258803400000006452798929521711257_)" },
					d: "m 15.489873,95.030674 c 1.892,6.078996 7.925,10.901996 11.233,4.936 2.306,-5.49 -0.166,-12.741 -3.917,-15.558 -4.568,-3.429 -8.787,0.737 -7.921,7.821 0.102,0.832 0.351,1.984 0.605,2.801 z",
					id: "path1482"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000000199521709349947990000013169840349870900097_)" },
					d: "m 7.5158734,70.013674 c 2.378,-4.995 3.1289996,-13.57 1.411,-16.097 -1.614,-2.373 -4.542,1.657 -5.803,7.985 -0.724,3.636 -0.73,7.313 -0.014,9.366 0.157,0.448 1.608,4.219 4.406,-1.254 z",
					id: "path1495"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000139986685407783468530000007711435610983319217_)" },
					d: "m 10.704873,100.06167 c 0.583,-5.955996 -2.1839996,-14.366996 -4.6739996,-16.297996 -2.404,-1.864 -3.651,2.352 -2.517,8.511 0.645,3.506 1.984,7.011 3.411,8.929996 0.489,0.657 2.973,3.697 3.7799996,-1.143 z",
					id: "path1508"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000145767616473413220620000003275638393888781987_)" },
					d: "m 22.884873,77.270674 c -0.028,0.57 -0.011,1.333 0.042,1.902 0.696,7.403 7.609,11.961 12.435,5.951 2.975,-4.11 2.589,-10.936 -0.825,-14.607 -4.622,-4.971 -11.265,-1.12 -11.652,6.754 z",
					id: "path1521"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000168828492323578885110000006331516876797389706_)" },
					d: "m 16.733873,55.042674 c 3.849,-5.183 4.466,-11.175 3.432,-13.508 -1.531,-3.452 -6.284,-0.03 -8.769,6.312 -1.281,3.269 -1.247,5.625 -1.173,6.486 0.265,3.087 2.517,5.447 6.51,0.71 z",
					id: "path1534"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000119825009282355398870000002427391825971570065_)" },
					d: "m 22.097873,113.19767 c 0.647,-4.622 -3.229,-12.573 -7.031,-14.420996 -3.364,-1.635 -4.781,2.167996 -2.862,7.676996 0.576,1.653 1.405,3.295 2.396,4.748 2.58,3.779 6.62,6.574 7.497,1.996 z",
					id: "path1547"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000135687005885930954780000007562071303343076235_)" },
					d: "m 0.00287342,77.043674 c 0.048,4.972 0.7,9.619 1.48499998,10.579 0.761,0.93 1.141,-1.721 1.266,-2.592 0.698,-5.494 0.024,-15.099 -1.164,-16.576 -0.89999998,-1.119 -1.64199998,2.895 -1.58699998,8.589 z",
					id: "path1560"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000027573844424622963070000005045413081647210387_)" },
					d: "m 26.881873,48.033674 c -0.355,1.066 -0.548,2.125 -0.573,3.147 -0.136,5.589 4.837,8.404 9.919,3.521 3.084,-3.214 4.138,-8.407 2.35,-11.576 -2.601,-4.611 -9.488,-1.721 -11.696,4.908 z",
					id: "path1573"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000137812898909728225410000000398060100545818550_)" },
					d: "m 39.869873,112.65967 c 2.08,-4.578 -0.768,-10.544 -4.704,-12.818996 -4.774,-2.76 -8.827,0.794996 -7.479,6.557996 1.427,6.099 8.774,11.834 12.183,6.261 z",
					id: "path1586"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000036210321468949231540000007790552816983797179_)" },
					d: "m 4.4348734,98.981674 c -0.941,-0.445 -0.176,2.929996 1.67,7.369996 1.936,4.656 4.0789996,8.162 4.8659996,8.516 0.669,0.301 0.234,-1.411 0.049,-2.142 -1.5109996,-5.284 -5.2649996,-13.119996 -6.5849996,-13.743996 z",
					id: "path1599"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000177472600690211122990000006503221024441719981_)" },
					d: "m 5.1048734,54.535674 c 2.658,-5.291 4.872,-12.708 4.368,-13.744 -0.43,-0.883 -2.388,2.377 -4.19,6.977 -1.627,4.156 -2.631,8.213 -2.237,9.044 0.394,0.831 1.648,-1.508 2.059,-2.277 z",
					id: "path1612"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000043438139329708308660000015822744963709389210_)" },
					d: "m 47.224873,69.120674 c 3.815,-4.626 2.555,-9.377 1.209,-11.455 -3.778,-5.832 -11.911,-2.997 -13.185,4.595 -0.082,0.486 -0.138,1.144 -0.14,1.636 -0.017,6.744 6.596,10.788 12.116,5.224 z",
					id: "path1625"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000050621569454675735740000001964733990937374595_)" },
					d: "m 23.593873,35.029674 c -0.895,1.614 -1.433,3.321 -1.474,4.682 -0.097,3.153 2.497,5.114 6.941,1.145 3.144,-2.99 5.064,-7.943 4.109,-10.599 -1.291,-3.587 -6.809,-0.218 -9.576,4.772 z",
					id: "path1638"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000099660364721125034880000005073820371753241730_)" },
					d: "m 48.636873,98.959674 c 3.407,-4.899 0.778,-10.218 -1.679,-12.42 -4.923,-4.412 -11.586,-1.028 -11.317,5.747 0.256,6.459 7.766,12.643996 12.996,6.673 z",
					id: "path1651"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000152981512894964917610000006976944404649027202_)" },
					d: "m 25.565873,120.54767 c 2.582,4.139 8.725,8.648 9.751,4.096 0.439,-4.473 -3.861,-10.211 -7.558,-11.596 -3.597,-1.348 -5.073,1.772 -2.925,6.182 0.198,0.407 0.493,0.934 0.732,1.318 z",
					id: "path1664"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000059298183092284374220000017110963526683306148_)" },
					d: "m 21.151873,126.23867 c 1.842,0.979 1.322,-0.973 1.151,-1.614 -1.176,-3.928 -6.402,-11.324 -8.857,-11.883 -1.668,-0.38 -1.061,2.63 1.299,6.442 v 0 c 2.188,3.534 4.934,6.272 6.407,7.055 z",
					id: "path1677"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000052810101756662128740000009060811739823908506_)" },
					d: "m 10.772873,42.161674 c 0.065,0.579 0.527,2.193 3.733,-1.324 3.764,-4.472 6.025,-10.117 5.654,-11.595 -0.424,-1.691 -3.909,1.304 -6.659,5.722 v 0 c -2.07,3.326 -2.862,6.011 -2.728,7.197 z",
					id: "path1690"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000030467902775817769060000007710743212976295583_)" },
					d: "m 60.657873,83.796674 c 3.656,-4.4 1.938,-9.254 -0.11,-11.443 -4.574,-4.891 -12.094,-1.876 -12.572,5.041 -0.016,0.233 -0.024,0.545 -0.02,0.778 0.123,6.594 7.362,10.868 12.702,5.624 z",
					id: "path1703"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000180341006968639202810000003347100774493131935_)" },
					d: "m 35.600873,134.66367 c -1.533,-3.849 -7.232,-9.348 -9.679,-9.34 -1.608,0.005 -0.993,2.363 1.342,5.149 1.711,2.041 4.171,4.084 6.122,5.083 1.958,1.003 2.703,0.702 2.215,-0.892 z",
					id: "path1716"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000172437836869410601830000017357335535451569809_)" },
					d: "m 27.098873,28.250674 c 3.431,-2.867 6.175,-7.401 5.931,-8.964 -0.292,-1.871 -4.604,0.931 -7.49,4.313 -1.621,1.899 -2.673,3.795 -2.816,5.073 -0.15,1.358 0.89,2.367 4.375,-0.422 z",
					id: "path1729"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000078723697224134013200000007992507812905159567_)" },
					d: "m 41.550873,35.115674 c -0.342,0.819 -0.539,1.631 -0.587,2.414 -0.293,4.756 4.812,6.382 8.811,2.805 3.517,-3.419 3.196,-6.951 2.452,-8.499 -2.152,-4.476 -8.565,-1.784 -10.676,3.28 z",
					id: "path1742"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000163053878163007453100000004624683950133212288_)" },
					d: "m 53.432873,123.96467 c 1.739,-3.333 -0.444,-7.607 -3.574,-9.508 -4.426,-2.689 -8.503,0.005 -7.151,4.724 1.318,4.602 7.808,8.962 10.725,4.784 z",
					id: "path1755"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000028292862012794903440000011988512145044200613_)" },
					d: "m 42.865873,27.994674 c 3.39,-2.887 4.118,-6.083 3.78,-7.527 -0.748,-3.191 -5.932,-0.808 -8.624,3.099 v 0 c -0.915,1.328 -1.248,2.384 -1.367,3.035 -0.555,3.065 2.257,4.336 6.211,1.393 z",
					id: "path1768"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000042718578562191629250000012247638859564900779_)" },
					d: "m 48.884873,134.44667 c 0.364,-3.179 -3.48,-7.884 -7.092,-8.68 -2.941,-0.648 -3.994,1.629 -2.168,4.687 2.289,3.831 8.313,7.468 9.26,3.993 z",
					id: "path1781"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000132770191053423491140000007632210908060457144_)" },
					d: "m 62.418873,111.64167 c 2.777,-3.585 0.967,-7.563 -0.926,-9.363 -4.373,-4.155996 -11.013,-1.592 -10.604,4.094 0.404,5.614 7.25,9.648 11.53,5.269 z",
					id: "path1794"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000163068424181906487300000009725152635015269520_)" },
					d: "m 62.330873,44.956674 c -2.912,-5.088 -10.739,-3.064 -12.137,3.14 -0.088,0.389 -0.16,0.918 -0.177,1.316 -0.233,5.396 5.77,8.606 10.814,4.187 3.897,-4.137 1.757,-8.194 1.5,-8.643 z",
					id: "path1807"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000034077442624591069820000009218002277992221871_)" },
					d: "m 18.053873,27.944674 c 2.348,-2.403 7.45,-8.318 7.377,-8.985 -0.37,-0.21 -3,2.218 -5.104,4.529 -2.231,2.45 -4.533,5.465 -4.364,6.062 0.266,0.12 1.028,-0.555 2.091,-1.606 z",
					id: "path1820"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000157995984871680439450000004804474724353645455_)" },
					d: "m 18.311873,125.62467 c -0.118,0.468 1.822,2.812 3.708,4.78 v 0 c 2.859,2.984 5.891,5.468 6.276,5.333 0.022,-0.162 -0.19,-0.471 -0.908,-1.324 -1.639,-1.885 -8.325,-9.068 -9.076,-8.789 z",
					id: "path1833"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000176037832161755113060000007618979071475921058_)" },
					d: "m 63.472873,92.385674 c -0.313,6.102 7.031,9.452996 11.39,5.196 3.174,-3.475 1.715,-7.141 0.352,-8.76 -3.971,-4.718 -11.433,-2.453 -11.742,3.564 z",
					id: "path1846"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000113354167512336820520000006842766831457106848_)" },
					d: "m 74.545873,67.640674 c 3.263,-3.594 1.865,-7.295 0.525,-8.915 -3.799,-4.591 -11.13,-2.419 -11.886,3.52 -0.024,0.189 -0.044,0.444 -0.05,0.635 -0.163,5.125 6.054,9.595 11.411,4.76 z",
					id: "path1859"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000064318501803466698530000000160626057362371239_)" },
					d: "m 49.252873,142.74867 c -1.377,-2.7 -6.292,-6.448 -8.481,-6.467 -1.472,-0.013 -0.959,1.655 1.1,3.571 1.382,1.286 3.303,2.556 5.014,3.314 1.398,0.619 2.944,1.05 2.367,-0.418 z",
					id: "path1872"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000124135087498030474290000011655190472795675011_)" },
					d: "m 40.632873,142.73067 c -2.712,-2.451 -8.235,-6.491 -9.416,-6.476 -0.724,0.01 0.487,1.539 3.19,3.571 v 0 c 2.987,2.246 6.651,4.168 6.977,3.827 -0.011,-0.179 -0.159,-0.36 -0.751,-0.922 z",
					id: "path1885"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000107549470292331867980000014750780667726015912_)" },
					d: "m 41.170873,17.240674 c 3.573,-2.496 5.185,-5.265 5.219,-6.127 0.063,-1.5969999 -3.912,0.314 -6.654,2.814 -1.319,1.202 -2.223,2.409 -2.48,3.311 -0.365,1.275 0.608,2.119 3.915,0.002 z",
					id: "path1898"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000102516119588716095730000007221224109596897212_)" },
					d: "m 30.783873,17.222674 c 3.259,-2.313 7.197,-5.95 7.306,-6.578 0.118,-0.6769999 -3.094,1.111 -5.825,3.243 -2.488,1.943 -3.962,3.621 -4.131,4.275 -0.101,0.389 0.11,0.784 2.65,-0.94 z",
					id: "path1911"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000128477840900087556850000015154316707693435269_)" },
					d: "m 56.581873,23.705674 c -0.155,0.378 -0.297,0.9 -0.344,1.269 -0.458,3.569 3.712,4.982 6.864,2.326 2.759,-2.561 1.886,-5.064 1.684,-5.54 -1.412,-3.308 -6.548,-2.09 -8.204,1.945 z",
					id: "path1924"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000056407624679554967980000016847754198413517485_)" },
					d: "m 63.552873,127.14867 c -3.026,-1.686 -6.541,-0.22 -5.57,3.281 0.875,3.155 5.533,6.091 7.894,3.263 1.472,-2.319 -0.013,-5.256 -2.324,-6.544 z",
					id: "path1937"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000167376588874201946570000018213694390410607493_)" },
					d: "m 66.568873,119.19667 c 0.134,4.011 5.118,6.818 8.584,3.708 1.845,-1.84 1.723,-4.839 -0.273,-6.684 -2.989,-2.764 -8.459,-1.449 -8.311,2.976 z",
					id: "path1950"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000057112839509476852940000013562575419161609146_)" },
					d: "m 65.725873,35.167674 c -0.028,0.14 -0.057,0.33 -0.072,0.472 -0.427,4.149 4.53,6.892 8.553,3.489 1.794,-1.68 2.122,-4.305 0.779,-6.243 -2.49,-3.592 -8.375,-2.142 -9.26,2.282 z",
					id: "path1963"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000079460158622750419550000016549781586481150880_)" },
					d: "m 61.245873,142.41667 c 0.409,-1.808 -2.179,-5.063 -5.045,-5.59 -1.941,-0.357 -3.059,0.905 -1.593,3.067 1.625,2.394 5.936,4.681 6.638,2.523 z",
					id: "path1976"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000070106482567904741890000001921094174100306831_)" },
					d: "m 56.335873,16.799674 c 2.953,-2.289 2.66,-4.565 2.646,-4.661 -0.348,-2.3999999 -4.307,-0.928 -6.371,1.804 -0.664,0.879 -0.894,1.573 -0.97,2.001 -0.388,2.186 2.2,2.658 4.695,0.856 z",
					id: "path1989"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000144295474034070890990000007817825231218805413_)" },
					d: "m 45.175873,8.3956741 c 2.093,-1.071 6.31,-3.769 6.292,-4.203 -0.297,-0.222 -2.941,0.851 -5.143,2.087 -2.184,1.226 -3.442,2.301 -3.555,2.729 -0.068,0.254 0.156,0.511 2.406,-0.613 z",
					id: "path2002"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000127730992518369212560000004935042208330688432_)" },
					d: "m 54.442873,148.87667 c -1.761,-1.124 -7.401,-4.208 -8.257,-3.955 -0.422,0.125 0.633,1.067 2.822,2.219 2.408,1.267 5.445,2.375 6.042,2.309 0.01,-0.021 0.023,-0.05 0.033,-0.071 -0.089,-0.124 -0.209,-0.218 -0.64,-0.502 z",
					id: "path2015"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000110446295796125680660000011187903342483015593_)" },
					d: "m 79.208873,77.455674 c -0.437,4.981 5.463,8.604 9.831,4.578 2.348,-2.438 1.945,-5.823 0.373,-7.77 -3.263,-4.04 -9.747,-2.011 -10.204,3.192 z",
					id: "path2028"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000070807209349108861420000004662275095824104121_)" },
					d: "m 79.743873,106.46667 c -0.396,3.95 4.417,6.805 8.162,3.666 1.813,-1.673 2.106,-4.419 0.666,-6.254 -2.627,-3.346 -8.403,-1.653 -8.828,2.588 z",
					id: "path2041"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000181766665731215728440000002795684730232666788_)" },
					d: "m 88.055873,51.993674 c 2.265,-2.603 1.039,-5.289 -0.043,-6.466 -2.95,-3.207 -8.273,-1.594 -8.63,2.616 -0.347,4.089 5.039,7.198 8.673,3.85 z",
					id: "path2054"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000139254581274291156830000007336169736159569559_)" },
					d: "m 55.564873,145.12567 c -0.805,0.114 -0.331,1 1.081,2.017 1.314,0.947 3.057,1.732 4.099,2.018 1.453,0.4 1.112,-0.186 0.983,-0.406 -1.124,-1.551 -4.748,-3.829 -6.163,-3.629 z",
					id: "path2067"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000153672128272945661450000018077986166064404644_)" },
					d: "m 54.944873,8.2366741 c 2.36,-1.378 3.698,-3.055 3.753,-3.568 0.098,-0.912 -2.675,0.189 -4.629,1.623 -0.954,0.7 -1.643,1.427 -1.842,1.945 -0.294,0.769 0.486,1.196 2.718,0 z",
					id: "path2080"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000088813030132609527630000000840570861706508965_)" },
					d: "m 95.573873,92.520674 c -0.015,0.113 -0.027,0.264 -0.031,0.377 -0.118,3.168 3.389,5.22 6.203997,2.699 1.438,-1.43 1.692,-3.681 0.592,-5.237 -1.949,-2.753 -6.310997,-1.36 -6.764997,2.161 z",
					id: "path2093"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000042003881320679131280000000817094036635403146_)" },
					d: "m 95.514873,62.364674 c -0.005,0.114 -0.005,0.266 0,0.38 0.149,3.308 3.995,5.476 6.611997,2.804 1.353,-1.541 1.222,-4.049 -0.292,-5.591 -2.327997,-2.371 -6.167997,-0.909 -6.319997,2.407 z",
					id: "path2106"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000170279427261400862440000004292432490584434101_)" },
					d: "m 59.493873,1.8876741 c 1.108,-0.401 4.023,-1.62399997 4.311,-1.84899997 0,-0.011 10e-4,-0.026 10e-4,-0.037 -0.255,-0.032 -1.845,0.399 -3.27,0.928 -1.463,0.54299997 -2.569,1.11999997 -2.519,1.31399997 0.159,0.083 0.706,-0.082 1.477,-0.356 z",
					id: "path2119"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000116941336711554308390000001645358138721819049_)" },
					d: "m 74.116873,15.961674 c 1.372,-1.34 0.782,-2.594 0.568,-2.947 -1.145,-1.89 -3.975,-0.952 -4.568,1.018 -0.039,0.13 -0.076,0.31 -0.09,0.445 -0.188,1.879 2.145,3.047 4.09,1.484 z",
					id: "path2132"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000051358159326764444480000009488012094096436618_)" },
					d: "m 75.129873,138.25967 c -1.694,-1.197 -3.838,-0.256 -3.586,1.573 0.232,1.678 2.607,3.229 4.166,1.716 0.975,-1.182 0.429,-2.576 -0.58,-3.289 z",
					id: "path2145"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000114040064972220396600000017173229231029556104_)" },
					d: "m 67.565873,7.6836741 c 1.301,-0.976 1.249,-1.93 1.226,-2.111 -0.168,-1.291 -2.247,-0.628 -3.251,0.739 -0.275,0.375 -0.365,0.682 -0.391,0.797 -0.238,1.057 0.935,1.543 2.416,0.575 z",
					id: "path2158"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000077319424412082093350000011191704370380397242_)" },
					d: "m 80.777873,130.44967 c -0.255,1.978 2.135,3.826 4.432,2.008 1.453,-1.369 1,-2.841 0.557,-3.427 -1.381,-1.832 -4.692,-0.891 -4.989,1.419 z",
					id: "path2171"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000153690920891616182350000006129345594591774860_)" },
					d: "m 85.111873,25.914674 c 1.32,-1.577 0.207,-3.093 -0.029,-3.381 -1.682,-2.048 -4.881,-1.276 -5.033,1.215 -0.141,2.303 3.065,4.073 5.062,2.166 z",
					id: "path2184"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000151545741716367953150000006428574012513285305_)" },
					d: "m 68.603873,145.75567 c -1.058,-0.178 -1.485,0.511 -0.877,1.418 0.757,1.129 2.815,2.171 3.244,1.152 0.265,-0.813 -0.959,-2.333 -2.367,-2.57 z",
					id: "path2197"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000067958700782405560120000004250833630487242895_)" },
					d: "m 94.079873,119.26767 c -0.016,0.068 -0.035,0.159 -0.046,0.228 -0.297,1.931 1.696,3.173 3.654,1.665 1.372,-1.264 1.119,-2.634 0.794,-3.182 -0.918,-1.548 -3.837,-1.001 -4.402,1.289 z",
					id: "path2210"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000102512024678794956260000011740393736788144049_)" },
					d: "m 98.381873,37.207674 c 0.753,-0.949 0.446,-2.539 -0.67,-3.471 -1.699,-1.418 -3.941,-0.519 -3.808,1.527 0.136,2.109 2.926,3.667 4.478,1.944 z",
					id: "path2223"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000104674109392723083100000001383324520108186250_)" },
					d: "m 66.746873,1.6376741 c 0.947,-0.452 1.686,-1.06299997 1.759,-1.26799997 0.118,-0.332 -1.099,0.074 -1.983,0.589 -0.487,0.28399997 -0.82,0.56299997 -0.889,0.74599997 -0.08,0.21 0.212,0.328 1.113,-0.067 z",
					id: "path2236"
				}),
				/* @__PURE__ */ _jsx("path", {
					style: { fill: "url(#SVGID_00000097486671545370010930000015418153806677484168_)" },
					d: "m 114.68187,76.331674 c -1.065,-1.389 -3.061,-0.602 -3.236,1.276 -0.012,0.126 -0.014,0.296 -0.006,0.423 0.118,1.847 2.043,2.682 3.169,1.376 0.892,-1.162 0.532,-2.475 0.073,-3.075 z",
					id: "path2249"
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2261",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2263",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2265",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2267",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2269",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2271",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2273",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2275",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2277",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2279",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2281",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2283",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2285",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2287",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "g2289",
			transform: "matrix(0.41438222,0,0,0.41438222,-4.55287,-1.5946778)"
		})
	]
});
export default SvgFaroSphereXgLogoMini;
